module.exports = __webpack_public_path__ + "img/BannerHomePat.55b8b5b3.webp";